import type { Plugin } from '@nuxt/types';
import { warRoomStates } from '~/components/partials/war-room/constants';

const logTransitionIntoWrMemberPlugin: Plugin = ({ app: { $analytics }, store }) => {
  const unwatch = store.watch(
    state => state.auth?.user,
    (user, oldUser) => {
      if (
        user &&
        oldUser &&
        user.warRoomState === warRoomStates.MEMBER &&
        oldUser.warRoomState === warRoomStates.IN_ONBOARDING
      ) {
        $analytics.logEvent('onboarding__become-member');

        unwatch();
      }
    },
    { deep: true },
  );
};

export default logTransitionIntoWrMemberPlugin;
